export const PENDING = 0;
export const UPDATED = 1;
export const DELETED = 2;
export const CORRECTION_STATUS = ["Pending", "Updated", "Deleted"];


// WEBPACK FOOTER //
// ./src/components/staffData/Constants.js